import { Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../localization'
import { WalletTransaction } from '../../types/walletTransaction'

export const fundingModeLabels = {
  unknown: 'Unknown funding',
  allowanceHold: 'Reservable allowance hold',
  cashHold: 'Cash hold',
  creditHold: 'Credit hold',
  pendingCredit: 'Pending credit (not received)'
} as const

export default function FundingModeLabel({
  transaction
}: {
  transaction: Pick<WalletTransaction, 'fundingMode' | 'usedBalanceType'>
}) {
  const mode = transaction.fundingMode
  const label =
    mode && Object.prototype.hasOwnProperty.call(fundingModeLabels, mode)
      ? fundingModeLabels[mode]
      : fundingModeLabels.unknown
  return (
    <>
      <Typography variant="body2">{getTranslate(label)}</Typography>
      <Typography variant="caption" color="textSecondary">
        {getTranslate(transaction.usedBalanceType || 'No recorded balance')}
      </Typography>
    </>
  )
}
